import {
  BREAKDOWN_AUDIENCE_MESSAGE_TYPES_UNCONFIGURED_SUBTITLE,
  BREAKDOWN_AUDIENCE_MESSAGE_TYPES_UNCONFIGURED_TITLE,
} from 'modules/intelligentInsights/constants';
import styled from 'styled-components';
import { EmptyState } from 'ui/emptyState';
import { Overview } from 'ui/illustrations';
import { spacing } from 'ui/theme';

const EmptyStateContainer = styled.div`
  margin: ${spacing.x8} 0;
`;

export const BREAKDOWN_MESSAGE_TYPE_UNCONFIGURED_TEST_ID = 'breakdown-message-type-unconfigured';

export const BreakdownMessageTypeUnconfigured = () => {
  return (
    <EmptyStateContainer data-test={BREAKDOWN_MESSAGE_TYPE_UNCONFIGURED_TEST_ID}>
      <EmptyState
        Illustration={Overview}
        title={BREAKDOWN_AUDIENCE_MESSAGE_TYPES_UNCONFIGURED_TITLE}
        subtitle={BREAKDOWN_AUDIENCE_MESSAGE_TYPES_UNCONFIGURED_SUBTITLE}
      />
    </EmptyStateContainer>
  );
};
